// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";
import { type Workflow, WorkflowFromJSON, WorkflowToJSON } from "../models/Workflow";

export interface WorkflowImageRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  workflowId: string;
}

export interface WorkflowListRequest {
  /**
   *
   */
  tenantId: string;
}

/**
 *
 */
export class WorkflowsApi extends runtime.BaseAPI {
  /**
   * Creates request options for workflowImageRetrieve without sending the request
   */
  async workflowImageRetrieveRequestOpts(
    requestParameters: WorkflowImageRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling workflowImageRetrieve().'
      );
    }

    if (requestParameters["workflowId"] == null) {
      throw new runtime.RequiredError(
        "workflowId",
        'Required parameter "workflowId" was null or undefined when calling workflowImageRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/workflows/{workflow_id}/image`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{workflow_id}",
      encodeURIComponent(String(requestParameters["workflowId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve the image configured for a workflow.
   * Get workflow image
   */
  async workflowImageRetrieveRaw(
    requestParameters: WorkflowImageRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const requestOptions = await this.workflowImageRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Retrieve the image configured for a workflow.
   * Get workflow image
   */
  async workflowImageRetrieve(
    requestParameters: WorkflowImageRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob | null | undefined> {
    const response = await this.workflowImageRetrieveRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for workflowList without sending the request
   */
  async workflowListRequestOpts(
    requestParameters: WorkflowListRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling workflowList().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/workflows`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return the workflow definitions available to a tenant.
   * List workflows
   */
  async workflowListRaw(
    requestParameters: WorkflowListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<Workflow>>> {
    const requestOptions = await this.workflowListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowFromJSON));
  }

  /**
   * Return the workflow definitions available to a tenant.
   * List workflows
   */
  async workflowList(
    requestParameters: WorkflowListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<Workflow> | null | undefined> {
    const response = await this.workflowListRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for workflowRefresh without sending the request
   */
  async workflowRefreshRequestOpts(): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/workflows/refresh`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Refresh workflow process membership from the current Prefect deployments.
   * Refresh workflow process membership
   */
  async workflowRefreshRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Blob>> {
    const requestOptions = await this.workflowRefreshRequestOpts();
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Refresh workflow process membership from the current Prefect deployments.
   * Refresh workflow process membership
   */
  async workflowRefresh(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Blob | null | undefined> {
    const response = await this.workflowRefreshRaw(initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }
}
